export default __webpack_public_path__ + "static/media/arcadia26.deaf2282.png";